import api from './api';

export const getCustomSenders = (page, params) => {
  return api.get('admin/CustomSender', { params: { page: page, limit: 5, ...params } });
};

export const getChannelCustomSender = channelUid => {
  return api.get(`admin/custom-sender/channel/${channelUid}`);
};

export const updateCustomSender = (customSenderId, data) => {
  return api.put(`admin/custom-sender/${customSenderId}`, { data });
};
